import { Component, OnInit } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatListModule} from "@angular/material/list";
import { CommonModule } from '@angular/common';
import { FieldResource } from "../../core/modules/openapi";

@Component({
  selector: "app-list",
  imports: [MatFormFieldModule, MatListModule, ReactiveFormsModule, CommonModule],
  template: `
    <mat-nav-list>
      <h3 mat-subheader> {{ field.displayName }} </h3>
      <mat-list-option *ngFor="let item of field.possibleValues"
                       [value]="item.name"> {{ item.name }}
      </mat-list-option>
      <mat-divider></mat-divider>
    </mat-nav-list>
  `,
  standalone: true,
  styleUrls: ['./list.component.css']
})
export class ListComponent implements OnInit {
  field: FieldResource;
  group: FormGroup;
  constructor() {}
  ngOnInit() {}
}
